/// <reference path="../../typings/tsd.d.ts" />

(function () {
    'use strict';

    angular
        .module('SiteRemi')
        .controller('remicuisinecguCtrl', remicuisinecguCtrl);

    remicuisinecguCtrl.$inject = ['$q', 'digiLookUp', '$scope', 'Page'];

    /* @ngInject */
    function remicuisinecguCtrl($q, digiLookUp, $scope, Page) {
        /* jshint validthis: true */
        var vm = this;

        Page.setTitle('Rémi Cuisine - Site de Rémi Privet');
        Page.setDescription('Politique de confidentialité de Rémi Cuisine, blog de cuisine et recettes');
        Page.setKeywords('Rémi Privet, Rémi Cuisine, cuisine, recettes, politique de confidentialité');
    }
})();
